import {IDropdownStyles} from "office-ui-fabric-react";

export class LocationItemsFiltersStyles {
    public static getDropdownStyle(): IDropdownStyles {
        return {
            root: {},
            label: {},
            dropdown: {},
            title: {},
            caretDownWrapper: {},
            caretDown: {},
            errorMessage: {},
            dropdownItemsWrapper: {},
            dropdownItems: {},
            dropdownItem: {},
            dropdownItemSelected: {},
            dropdownItemDisabled: {},
            dropdownItemSelectedAndDisabled: {},
            dropdownItemHidden: {},
            dropdownOptionText: {},
            dropdownDivider: {},
            dropdownItemHeader: {},
            panel: {},
            callout: {
                selectors: {
                    "& .ms-Dropdown-item:hover": {cursor: "pointer"},
                    "& .ms-Dropdown-header:hover": {cursor: "pointer", textDecoration: "underline"},
                },
            },
            subComponentStyles: {
                panel: {},
                label: {},
                multiSelectItem: {},
            },
        };
    }

    public static getDarkModeDropdownStyle(): IDropdownStyles {
        return {
            root: {},
            label: {},
            dropdown: {},
            title: {
                background: "transparent !important",
            },
            caretDownWrapper: {},
            caretDown: {},
            errorMessage: {},
            dropdownItemsWrapper: {},
            dropdownItems: {},
            dropdownItem: {},
            dropdownItemSelected: {},
            dropdownItemDisabled: {},
            dropdownItemSelectedAndDisabled: {},
            dropdownItemHidden: {},
            dropdownOptionText: {},
            dropdownDivider: {},
            dropdownItemHeader: {},
            panel: {},
            callout: {
                selectors: {
                    "& .ms-Dropdown-item": {backgroundColor: "black", color: "white"},
                    "& .ms-Dropdown-item:hover": {cursor: "pointer", backgroundColor: "rgb(93, 93, 93)", color: "white !important"},
                    "& .ms-Dropdown-header": {backgroundColor: "black"},
                    "& .ms-Dropdown-header:hover": {cursor: "pointer", textDecoration: "underline"},
                },
            },
            subComponentStyles: {
                panel: {},
                label: {},
                multiSelectItem: {
                    checkbox: {
                        background: "black",
                        selectors: {
                            "&:hover": {border: "none", background: "rgb(93, 93, 93)"},
                            "& .ms-Dropdown-item": {border: "none", backgroundColor: "black", color: "white"},
                            "& .ms-Dropdown-item:hover": {border: "none", backgroundColor: "rgb(93, 93, 93)"},
                            "& .is-checked:hover": {
                                border: "none !important",
                                backgroundColor: "rgb(93, 93, 93) !important",
                                color: "white !important",
                            },
                        },
                    },
                },
            },
        };
    }
}
